import { render, staticRenderFns } from "./code-snippet.vue?vue&type=template&id=4db4304e&"
import script from "./code-snippet.vue?vue&type=script&lang=js&"
export * from "./code-snippet.vue?vue&type=script&lang=js&"
import style0 from "./code-snippet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports